module.exports = __webpack_public_path__ + "img/big_1_45.30f9f26b.png";